var _path, _ellipse, _path2, _ellipse2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 147,
    viewBox: "0 0 148 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121 75.3571C121 103.997 97.7828 127.214 69.1429 127.214C40.503 127.214 17.2858 103.997 17.2858 75.3571C17.2858 46.7172 40.503 23.5 69.1429 23.5C97.7828 23.5 121 46.7172 121 75.3571Z",
    fill: "current",
    stroke: "none"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.2101,
    cy: 75.3571,
    rx: 44.7395,
    ry: 46.7731,
    fill: "white",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9768 88.772L68.1261 76.3739V44.902M69.1429 23.5C40.503 23.5 17.2858 46.7172 17.2858 75.3571C17.2858 103.997 40.503 127.214 69.1429 127.214C97.7828 127.214 121 103.997 121 75.3571C121 46.7172 97.7828 23.5 69.1429 23.5Z",
    stroke: "current",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.8645,
    cy: 142.765,
    rx: 32.8646,
    ry: 3.97393,
    fill: "current",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4902 60.5C89.8433 60.5 85.9218 57.4289 84.688 53.2271C84.1613 51.4335 84.8084 49.5653 85.7983 47.9747L102.808 17.3031C106.793 10.899 116.207 10.899 120.192 17.3031L137.202 47.9747C138.192 49.5653 138.839 51.4335 138.312 53.2271C137.078 57.4289 133.157 60.5 128.51 60.5H94.4902Z",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 39.2001V25.7434M111.5 49.1743V49.2926M128.51 60.5H94.4902C89.8433 60.5 85.9218 57.4289 84.688 53.2271C84.1613 51.4335 84.8084 49.5653 85.7983 47.9747L102.808 17.3031C106.793 10.899 116.207 10.899 120.192 17.3031L137.202 47.9747C138.192 49.5653 138.839 51.4335 138.312 53.2271C137.078 57.4289 133.157 60.5 128.51 60.5Z",
    stroke: "current",
    fill: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.117 18.1646L86.7493 47.9546C85.7968 49.4996 85.1741 51.3141 85.6809 53.0561C86.5343 55.9898 88.6511 58.0352 91.4456 58.9534C91.3649 58.7358 91.2917 58.5146 91.2264 58.29C90.7196 56.5479 91.3423 54.7334 92.2948 53.1885L108.663 23.3984C111.218 19.2527 116.095 17.8702 120.198 19.2507L119.5 17.9992C115.665 11.7791 106.952 11.9445 103.117 18.1646Z",
    fill: "current",
    stroke: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 49.2794,
    r: 0.807685,
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenExpired);
export default __webpack_public_path__ + "static/media/token-expired.50b867dec4692fe313a574c1cfcf9d6b.svg";
export { ForwardRef as ReactComponent };